import React from 'react';
import PropTypes from 'prop-types';
import {
  FDPrimaryActionButton,
  FDStack,
} from '@facet-wealth/design';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import fr from 'facet-rest';
import { FDInputRow } from 'Packages/FacetDesign/Components/Experimental/fdInputRow';
import MetaLayoutRemainingFields from 'Components/UI/Meta/MetaForm/Components/MetaLayout/MetaLayoutRemainingFields';
import { UnderlineButton } from 'Components/ComponentLibrary/Atoms/UnderlineButton';
import { WizardBackButtonRel } from 'Packages/FacetCore/Experimental/RelationshipComponents/WizardBackButtonRel';
import { dataAttrs } from 'Helpers/Testing';

export const AccountOpeningV2PersonalInformationStepLayout = ({ navigateToLink }) => {
  const { onSubmit, resource, saving } = useMetaLayoutContext();

  const updateName = resource.withRelationship(
    fr.relationships.updateName.name,
    (rel) => (
      <FDStack direction="row" justifyContent="flex-start">
        <UnderlineButton
          onClick={(e) => {
            e.preventDefault();
            navigateToLink(rel.link('related'));
          }}
          label={rel.meta('prompt')}
        />
      </FDStack>
    ),
    () => null,
  );

  return (
    <FDStack spacing={3} direction="column">
      <MetaControlField attr="title" />
      <MetaControlField attr="description" />

      <FDStack direction="column" spacing={3}>
        <FDStack direction="column" spacing={1}>
          <FDInputRow>
            <MetaControlField attr="firstName" />
            <MetaControlField attr="lastName" />
          </FDInputRow>
          {updateName}
        </FDStack>

        <FDInputRow>
          <MetaControlField attr="citizenshipCountry" />
          <MetaControlField attr="employmentStatus" />

          <MetaControlField attr="permanentResidentQuestion" />
          <MetaControlField attr="birthCountry" />
          <MetaControlField attr="visaExpirationDate" />
          <MetaControlField attr="visaType" />

          <MetaControlField attr="employer" />
          <MetaControlField attr="positionEmployed" />
        </FDInputRow>

        <MetaControlField attr="mailingAddressIsSameAsPhysical" />

        <FDStack direction="column" spacing={2}>
          <MetaControlField attr="mailingAddressSectionTitle" />
          <MetaLayoutRemainingFields horizontal noAccordion />
        </FDStack>
      </FDStack>


      <FDStack direction="row" justifyContent="center" alignItems="center" spacing={2}>
        <WizardBackButtonRel overrideOnClick={(_, rel) => navigateToLink(rel.link('related'))} resource={resource} />
        <FDPrimaryActionButton
          {...dataAttrs('continue-btn', resource)}
          label="Save and continue"
          loading={saving}
          onClick={onSubmit}
        />
      </FDStack>
    </FDStack>
  );
};

AccountOpeningV2PersonalInformationStepLayout.defaultProps = {};

AccountOpeningV2PersonalInformationStepLayout.propTypes = {
  navigateToLink: PropTypes.func.isRequired,
};
